import React from 'react';

import { useDispatch } from 'react-redux';

import { isAuthFailed } from '@/services/auth';
import useInterval from '../../util/useInterval';

export default function PollEntity({ poll_function, interval }) {
  const dispatch = useDispatch();

  useInterval(() => {
    if (isAuthFailed()) {
      return;
    }
    const thunk = poll_function();
    if (!thunk) {
      return;
    }
    try {
      const result = dispatch(thunk);
      if (result && typeof result.then === 'function') {
        result.catch(() => {
          // Auth recovery and the action's error snackbar handle this.
        });
      }
    } catch {
      // A thrown poll should not become an unhandled rejection.
    }
  }, interval);

  return <div></div>;
}
